export const updateByKey = (key, value) => ({
  type: 'LINE_PAYMENT/UPDATE_BY_KEY',
  key,
  value
})
